import axios from "axios";
import { ServerSideTypes } from "../../common/OperationCommonTypes";
import EquipmentKitTypes from "./Types";

export namespace EquipmentKitRequests {
  export interface GetAll {
    code?: string;
    description?: string;
  }
  
  export interface Create {
    code: string;
    descr: string;
    equipmentsId: number[];
  }

  export interface Update {
    code: string;
    descr: string;
    equipmentsId: number[];
  }
}

export const EquipmentKitService = {
  get: {
    valids: (tenant:string) => {
      return axios.get("masterdatavehicle/equipment/valid", { params:  {tenant:tenant} }).then(
        response => {
          return response.data as EquipmentKitTypes.IEquipmentsValid[];
        }
      );
    },
    all: (tenant:string, data: EquipmentKitRequests.GetAll, serverParams: ServerSideTypes.IParams) => {
      return axios.get<ServerSideTypes.IResult<EquipmentKitTypes.IEquipmentKit>>("masterdatavehicle/equipmentkit", { params: { tenant, ...data, ...serverParams } }).then(
        response => response.data
      );
    },
    byId: (tenant:string,id: number) => {
      return axios.get<EquipmentKitTypes.IEquipmentKit>(`masterdatavehicle/equipmentKit/${id}`,{ params:  {tenant:tenant} }).then(
        response => response.data
      )
    },
    equipmentsById: (tenant:string,id: number, serverParams: ServerSideTypes.IParams) => {
      const emptyResponse = {"content":[],"pageNumber":0,"pageSize":10,"totalElements":0,"totalPages":0};
      if (!id) { return Promise.resolve(emptyResponse); }
      return axios.get<ServerSideTypes.IResult<EquipmentKitTypes.IEquipmentsValid>>(`masterdatavehicle/equipment/equipmentkit/${id}`, { params:  {...serverParams,tenant} }).then(
        response => response.data
      ).catch(() => {
        return emptyResponse;
      })
    }
  },
  create: {
    equipmentKit: (tenant:string,data: EquipmentKitRequests.Create) => {
      return axios.post("masterdatavehicle/equipmentKit", data,{ params:  {tenant:tenant} });
    }
  },
  update: {
    kit: (tenant:string,id: number, data: EquipmentKitRequests.Update) => {
      return axios.put(`masterdatavehicle/equipmentKit/${id}`, data,{ params:  {tenant:tenant} }).then(
        response => response.data,
      )
    },
    addEquipment: (tenant:string,id: number, data: EquipmentKitRequests.Update) => {
      return axios.put(`masterdatavehicle/equipmentKit/${id}`, data,{ params:  {tenant:tenant} }).then(
        response => response.data
      )
    }
  },
  delete: {
    kit: (tenant:string,id: number) => {
      return axios.delete(`masterdatavehicle/equipmentKit/${id}`,{ params:  {tenant:tenant} }).then(
        response => response.data,
      )
    },
    equipment: (tenant:string,kitId: number, equipmentId: number) => {
      return axios.put(`masterdatavehicle/equipmentKit/${kitId}/detachequipment/${equipmentId}`,undefined,{params:{tenant:tenant}}).then(
        response => response.data,
      )
    }
  }
}